module.exports = __webpack_public_path__ + "public/SiteIcons/exitpageIconTwo.svg?00f58533";